import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import GlobalBackgroundFX from "@/components/GlobalBackgroundFX";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import ContentProtection from "@/components/ContentProtection";

export default function PublicLayout() {
  return (
    <div className="public-shell protected-public-shell min-h-screen flex flex-col">
      <GlobalBackgroundFX />
      <AnalyticsTracker />
      <ContentProtection />
      <Navbar />
      <main className="public-main flex-1 pt-20">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
